/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-op-assessment.reducer';

export const PreOpAssessment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preOpAssessmentList = useAppSelector(state => state.preOpAssessment.entities);
  const loading = useAppSelector(state => state.preOpAssessment.loading);
  const totalItems = useAppSelector(state => state.preOpAssessment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-op-assessment-heading" data-cy="PreOpAssessmentHeading">
        <Translate contentKey="tinyMedicRestApp.preOpAssessment.home.title">Pre Op Assessments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pre-op-assessment/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preOpAssessment.home.createLabel">Create new Pre Op Assessment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preOpAssessment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preOpAssessmentList && preOpAssessmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('surgeryDateTime')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.surgeryDateTime">Surgery Date Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('surgeryDateTime')} />
                </th>
                <th className="hand" onClick={sort('hypertension')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.hypertension">Hypertension</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hypertension')} />
                </th>
                <th className="hand" onClick={sort('diabetes')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.diabetes">Diabetes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('diabetes')} />
                </th>
                <th className="hand" onClick={sort('asthma')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.asthma">Asthma</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('asthma')} />
                </th>
                <th className="hand" onClick={sort('allergy')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.allergy">Allergy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allergy')} />
                </th>
                <th className="hand" onClick={sort('epilepsy')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.epilepsy">Epilepsy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('epilepsy')} />
                </th>
                <th className="hand" onClick={sort('ihd')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.ihd">Ihd</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ihd')} />
                </th>
                <th className="hand" onClick={sort('thyroid')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.thyroid">Thyroid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('thyroid')} />
                </th>
                <th className="hand" onClick={sort('previousSurgeyInfo')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.previousSurgeyInfo">Previous Surgey Info</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('previousSurgeyInfo')} />
                </th>
                <th className="hand" onClick={sort('historyOfTB')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.historyOfTB">History Of TB</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOfTB')} />
                </th>
                <th className="hand" onClick={sort('otherHistory')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherHistory">Other History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherHistory')} />
                </th>
                <th className="hand" onClick={sort('icterus')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.icterus">Icterus</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('icterus')} />
                </th>
                <th className="hand" onClick={sort('pallor')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.pallor">Pallor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pallor')} />
                </th>
                <th className="hand" onClick={sort('lymphadenopathy')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.lymphadenopathy">Lymphadenopathy</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lymphadenopathy')} />
                </th>
                <th className="hand" onClick={sort('edema')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.edema">Edema</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('edema')} />
                </th>
                <th className="hand" onClick={sort('airwayDentition')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.airwayDentition">Airway Dentition</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('airwayDentition')} />
                </th>
                <th className="hand" onClick={sort('thyroidText')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.thyroidText">Thyroid Text</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('thyroidText')} />
                </th>
                <th className="hand" onClick={sort('spine')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.spine">Spine</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('spine')} />
                </th>
                <th className="hand" onClick={sort('mallampatiGrade')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.mallampatiGrade">Mallampati Grade</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mallampatiGrade')} />
                </th>
                <th className="hand" onClick={sort('tmDistance')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.tmDistance">Tm Distance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tmDistance')} />
                </th>
                <th className="hand" onClick={sort('cvs')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.cvs">Cvs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cvs')} />
                </th>
                <th className="hand" onClick={sort('respiratorySystem')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.respiratorySystem">Respiratory System</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('respiratorySystem')} />
                </th>
                <th className="hand" onClick={sort('git')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.git">Git</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('git')} />
                </th>
                <th className="hand" onClick={sort('cns')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.cns">Cns</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cns')} />
                </th>
                <th className="hand" onClick={sort('otherFindings')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherFindings">Other Findings</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherFindings')} />
                </th>
                <th className="hand" onClick={sort('psychologicalNeeds')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.psychologicalNeeds">Psychological Needs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('psychologicalNeeds')} />
                </th>
                <th className="hand" onClick={sort('socialNeeds')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.socialNeeds">Social Needs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('socialNeeds')} />
                </th>
                <th className="hand" onClick={sort('economicNeeds')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.economicNeeds">Economic Needs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('economicNeeds')} />
                </th>
                <th className="hand" onClick={sort('otherInvestigations')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.otherInvestigations">Other Investigations</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherInvestigations')} />
                </th>
                <th className="hand" onClick={sort('dischargeNeeds')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.dischargeNeeds">Discharge Needs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dischargeNeeds')} />
                </th>
                <th className="hand" onClick={sort('ecg')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.ecg">Ecg</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ecg')} />
                </th>
                <th className="hand" onClick={sort('echo')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.echo">Echo</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('echo')} />
                </th>
                <th className="hand" onClick={sort('chestXRay')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.chestXRay">Chest X Ray</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chestXRay')} />
                </th>
                <th className="hand" onClick={sort('typeOfAnaesthesia')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.typeOfAnaesthesia">Type Of Anaesthesia</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('typeOfAnaesthesia')} />
                </th>
                <th className="hand" onClick={sort('aSaCategory')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.aSaCategory">A Sa Category</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('aSaCategory')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('testsIgnored')}>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.testsIgnored">Tests Ignored</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('testsIgnored')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.vitals">Vitals</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpAssessment.labPres">Lab Pres</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preOpAssessmentList.map((preOpAssessment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-op-assessment/${preOpAssessment.id}`} color="link" size="sm">
                      {preOpAssessment.id}
                    </Button>
                  </td>
                  <td>{preOpAssessment.surgeryDateTime}</td>
                  <td>{preOpAssessment.hypertension ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.diabetes ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.asthma ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.allergy ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.epilepsy ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.ihd ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Thyroid.${preOpAssessment.thyroid}`} />
                  </td>
                  <td>{preOpAssessment.previousSurgeyInfo}</td>
                  <td>{preOpAssessment.historyOfTB}</td>
                  <td>{preOpAssessment.otherHistory}</td>
                  <td>{preOpAssessment.icterus ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.pallor ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.lymphadenopathy}</td>
                  <td>{preOpAssessment.edema ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.airwayDentition}</td>
                  <td>{preOpAssessment.thyroidText}</td>
                  <td>{preOpAssessment.spine}</td>
                  <td>{preOpAssessment.mallampatiGrade}</td>
                  <td>{preOpAssessment.tmDistance}</td>
                  <td>{preOpAssessment.cvs}</td>
                  <td>{preOpAssessment.respiratorySystem}</td>
                  <td>{preOpAssessment.git}</td>
                  <td>{preOpAssessment.cns}</td>
                  <td>{preOpAssessment.otherFindings}</td>
                  <td>{preOpAssessment.psychologicalNeeds ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.socialNeeds ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.economicNeeds ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.otherInvestigations}</td>
                  <td>{preOpAssessment.dischargeNeeds}</td>
                  <td>{preOpAssessment.ecg}</td>
                  <td>{preOpAssessment.echo}</td>
                  <td>{preOpAssessment.chestXRay}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TypeOfAnaesthesia.${preOpAssessment.typeOfAnaesthesia}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ASACategory.${preOpAssessment.aSaCategory}`} />
                  </td>
                  <td>{preOpAssessment.active ? 'true' : 'false'}</td>
                  <td>{preOpAssessment.cursor}</td>
                  <td>{preOpAssessment.lastupdated}</td>
                  <td>{preOpAssessment.microSec}</td>
                  <td>{preOpAssessment.timestampentry}</td>
                  <td>{preOpAssessment.testsIgnored ? 'true' : 'false'}</td>
                  <td>
                    {preOpAssessment.surgery ? (
                      <Link to={`/patient-procedure/${preOpAssessment.surgery.id}`}>{preOpAssessment.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preOpAssessment.anaesthesiologist ? (
                      <Link to={`/doctor/${preOpAssessment.anaesthesiologist.id}`}>{preOpAssessment.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {preOpAssessment.vitals ? <Link to={`/vitals/${preOpAssessment.vitals.id}`}>{preOpAssessment.vitals.id}</Link> : ''}
                  </td>
                  <td>
                    {preOpAssessment.labPres ? (
                      <Link to={`/lab-prescription/${preOpAssessment.labPres.id}`}>{preOpAssessment.labPres.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pre-op-assessment/${preOpAssessment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-op-assessment/${preOpAssessment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-op-assessment/${preOpAssessment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preOpAssessment.home.notFound">No Pre Op Assessments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preOpAssessmentList && preOpAssessmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreOpAssessment;
